/**
 * @file   InsightCallout.js
 * @brief  Contextual insight text card below the slider on Match tab.
 *         Updates dynamically as the slider moves (Tier 1) or shows static
 *         messages for lower tiers.
 */
import React from "react";
import { buildInsightText } from "../../../helpers/matchDemandUtils";
import "./InsightCallout/insight_callout.scss";

const InsightCallout = ({
  askingPrice,
  sliderPrice,
  prices,
  matchCount,
  adType,
  rangeMin,
  rangeMax,
}) => {
  const text = buildInsightText(askingPrice, sliderPrice, prices, matchCount, adType, {
    rangeMin,
    rangeMax,
  });

  if (!text) return null;

  return (
    <div className="insight-callout">
      <svg className="insight-callout__icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.2" />
        <path d="M7 6V10" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <circle cx="7" cy="4.5" r="0.75" fill="currentColor" />
      </svg>
      <span className="insight-callout__text">{text}</span>
    </div>
  );
};

export default InsightCallout;
